import { render, staticRenderFns } from "./report-child6.vue?vue&type=template&id=4a8838b3&scoped=true&"
import script from "./report-child6.vue?vue&type=script&lang=ts&"
export * from "./report-child6.vue?vue&type=script&lang=ts&"
import style0 from "./report-child6.vue?vue&type=style&index=0&id=4a8838b3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8838b3",
  null
  
)

export default component.exports